// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as OauthResultRouteImport } from './routes/oauth-result'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as userRouteRouteImport } from './routes/(user)/route'
import { Route as publicRouteRouteImport } from './routes/(public)/route'
import { Route as userTmpRouteImport } from './routes/(user)/tmp'
import { Route as userOnboardingRouteImport } from './routes/(user)/onboarding'
import { Route as usertenantBcRouteRouteImport } from './routes/(user)/(tenantBc)/route'
import { Route as publicIndexRouteImport } from './routes/(public)/index'
import { Route as publicPricingRouteImport } from './routes/(public)/pricing'
import { Route as publicContactRouteImport } from './routes/(public)/contact'
import { Route as publicAuthRouteRouteImport } from './routes/(public)/auth/route'
import { Route as userTTenantSlugRouteRouteImport } from './routes/(user)/t.$tenantSlug/route'
import { Route as usertenantBcSettingsRouteImport } from './routes/(user)/(tenantBc)/settings'
import { Route as usertenantBcPurchaseRouteImport } from './routes/(user)/(tenantBc)/purchase'
import { Route as usertenantBcDashboardRouteImport } from './routes/(user)/(tenantBc)/dashboard'
import { Route as usertenantBcAccountRouteImport } from './routes/(user)/(tenantBc)/account'
import { Route as publicStoriesIndexRouteImport } from './routes/(public)/stories/index'
import { Route as publicStoriesSlugRouteImport } from './routes/(public)/stories/$slug'
import { Route as publicLegalSlugRouteImport } from './routes/(public)/legal.$slug'
import { Route as publicAuthIndexRouteImport } from './routes/(public)/auth/index'
import { Route as publicAuthLoginRouteImport } from './routes/(public)/auth/login'
import { Route as userTTenantSlugSubscriptionRouteImport } from './routes/(user)/t.$tenantSlug/subscription'
import { Route as userTTenantSlugSettingsRouteImport } from './routes/(user)/t.$tenantSlug/settings'
import { Route as userTTenantSlugRunsRouteImport } from './routes/(user)/t.$tenantSlug/runs'
import { Route as userTTenantSlugPurchaseRouteImport } from './routes/(user)/t.$tenantSlug/purchase'
import { Route as userTTenantSlugDashboardRouteImport } from './routes/(user)/t.$tenantSlug/dashboard'
import { Route as userTTenantSlugCheckoutRouteImport } from './routes/(user)/t.$tenantSlug/checkout'
import { Route as userTTenantSlugAccountRouteImport } from './routes/(user)/t.$tenantSlug/account'
import { Route as usertenantBcWorkflowsIndexRouteImport } from './routes/(user)/(tenantBc)/workflows/index'
import { Route as usertenantBcPromptsIndexRouteImport } from './routes/(user)/(tenantBc)/prompts/index'
import { Route as usertenantBcEvaluationsIndexRouteImport } from './routes/(user)/(tenantBc)/evaluations/index'
import { Route as usertenantBcWorkflowsIdRouteImport } from './routes/(user)/(tenantBc)/workflows/$id'
import { Route as usertenantBcPromptsIdRouteImport } from './routes/(user)/(tenantBc)/prompts/$id'
import { Route as usertenantBcEvaluationsIdRouteImport } from './routes/(user)/(tenantBc)/evaluations/$id'
import { Route as publicAuthResetPasswordIndexRouteImport } from './routes/(public)/auth/reset-password/index'
import { Route as publicAuthVerifyRequestRouteImport } from './routes/(public)/auth/verify/request'
import { Route as publicAuthVerifyApplyRouteImport } from './routes/(public)/auth/verify/apply'
import { Route as publicAuthResetPasswordTokenRouteImport } from './routes/(public)/auth/reset-password/$token'
import { Route as userTTenantSlugWorkflowsIdRouteImport } from './routes/(user)/t.$tenantSlug/workflows.$id'
import { Route as userTTenantSlugPromptsIdRouteImport } from './routes/(user)/t.$tenantSlug/prompts.$id'
import { Route as userTTenantSlugKnowledgeBasesIdRouteImport } from './routes/(user)/t.$tenantSlug/knowledge-bases.$id'
import { Route as userTTenantSlugEvaluationsIdRouteImport } from './routes/(user)/t.$tenantSlug/evaluations.$id'

const OauthResultRoute = OauthResultRouteImport.update({
            id: '/oauth-result',path: '/oauth-result',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const userRouteRoute = userRouteRouteImport.update({
            id: '/(user)',getParentRoute: () => rootRouteImport
          })
const publicRouteRoute = publicRouteRouteImport.update({
            id: '/(public)',getParentRoute: () => rootRouteImport
          })
const userTmpRoute = userTmpRouteImport.update({
            id: '/tmp',path: '/tmp',getParentRoute: () => userRouteRoute
          })
const userOnboardingRoute = userOnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => userRouteRoute
          })
const usertenantBcRouteRoute = usertenantBcRouteRouteImport.update({
            id: '/(tenantBc)',getParentRoute: () => userRouteRoute
          })
const publicIndexRoute = publicIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => publicRouteRoute
          })
const publicPricingRoute = publicPricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => publicRouteRoute
          })
const publicContactRoute = publicContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => publicRouteRoute
          })
const publicAuthRouteRoute = publicAuthRouteRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => publicRouteRoute
          })
const userTTenantSlugRouteRoute = userTTenantSlugRouteRouteImport.update({
            id: '/t/$tenantSlug',path: '/t/$tenantSlug',getParentRoute: () => userRouteRoute
          })
const usertenantBcSettingsRoute = usertenantBcSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => usertenantBcRouteRoute
          })
const usertenantBcPurchaseRoute = usertenantBcPurchaseRouteImport.update({
            id: '/purchase',path: '/purchase',getParentRoute: () => usertenantBcRouteRoute
          })
const usertenantBcDashboardRoute = usertenantBcDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => usertenantBcRouteRoute
          })
const usertenantBcAccountRoute = usertenantBcAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => usertenantBcRouteRoute
          })
const publicStoriesIndexRoute = publicStoriesIndexRouteImport.update({
            id: '/stories/',path: '/stories/',getParentRoute: () => publicRouteRoute
          })
const publicStoriesSlugRoute = publicStoriesSlugRouteImport.update({
            id: '/stories/$slug',path: '/stories/$slug',getParentRoute: () => publicRouteRoute
          })
const publicLegalSlugRoute = publicLegalSlugRouteImport.update({
            id: '/legal/$slug',path: '/legal/$slug',getParentRoute: () => publicRouteRoute
          })
const publicAuthIndexRoute = publicAuthIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => publicAuthRouteRoute
          })
const publicAuthLoginRoute = publicAuthLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => publicAuthRouteRoute
          })
const userTTenantSlugSubscriptionRoute = userTTenantSlugSubscriptionRouteImport.update({
            id: '/subscription',path: '/subscription',getParentRoute: () => userTTenantSlugRouteRoute
          })
const userTTenantSlugSettingsRoute = userTTenantSlugSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => userTTenantSlugRouteRoute
          })
const userTTenantSlugRunsRoute = userTTenantSlugRunsRouteImport.update({
            id: '/runs',path: '/runs',getParentRoute: () => userTTenantSlugRouteRoute
          })
const userTTenantSlugPurchaseRoute = userTTenantSlugPurchaseRouteImport.update({
            id: '/purchase',path: '/purchase',getParentRoute: () => userTTenantSlugRouteRoute
          })
const userTTenantSlugDashboardRoute = userTTenantSlugDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => userTTenantSlugRouteRoute
          })
const userTTenantSlugCheckoutRoute = userTTenantSlugCheckoutRouteImport.update({
            id: '/checkout',path: '/checkout',getParentRoute: () => userTTenantSlugRouteRoute
          })
const userTTenantSlugAccountRoute = userTTenantSlugAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => userTTenantSlugRouteRoute
          })
const usertenantBcWorkflowsIndexRoute = usertenantBcWorkflowsIndexRouteImport.update({
            id: '/workflows/',path: '/workflows/',getParentRoute: () => usertenantBcRouteRoute
          })
const usertenantBcPromptsIndexRoute = usertenantBcPromptsIndexRouteImport.update({
            id: '/prompts/',path: '/prompts/',getParentRoute: () => usertenantBcRouteRoute
          })
const usertenantBcEvaluationsIndexRoute = usertenantBcEvaluationsIndexRouteImport.update({
            id: '/evaluations/',path: '/evaluations/',getParentRoute: () => usertenantBcRouteRoute
          })
const usertenantBcWorkflowsIdRoute = usertenantBcWorkflowsIdRouteImport.update({
            id: '/workflows/$id',path: '/workflows/$id',getParentRoute: () => usertenantBcRouteRoute
          })
const usertenantBcPromptsIdRoute = usertenantBcPromptsIdRouteImport.update({
            id: '/prompts/$id',path: '/prompts/$id',getParentRoute: () => usertenantBcRouteRoute
          })
const usertenantBcEvaluationsIdRoute = usertenantBcEvaluationsIdRouteImport.update({
            id: '/evaluations/$id',path: '/evaluations/$id',getParentRoute: () => usertenantBcRouteRoute
          })
const publicAuthResetPasswordIndexRoute = publicAuthResetPasswordIndexRouteImport.update({
            id: '/reset-password/',path: '/reset-password/',getParentRoute: () => publicAuthRouteRoute
          })
const publicAuthVerifyRequestRoute = publicAuthVerifyRequestRouteImport.update({
            id: '/verify/request',path: '/verify/request',getParentRoute: () => publicAuthRouteRoute
          })
const publicAuthVerifyApplyRoute = publicAuthVerifyApplyRouteImport.update({
            id: '/verify/apply',path: '/verify/apply',getParentRoute: () => publicAuthRouteRoute
          })
const publicAuthResetPasswordTokenRoute = publicAuthResetPasswordTokenRouteImport.update({
            id: '/reset-password/$token',path: '/reset-password/$token',getParentRoute: () => publicAuthRouteRoute
          })
const userTTenantSlugWorkflowsIdRoute = userTTenantSlugWorkflowsIdRouteImport.update({
            id: '/workflows/$id',path: '/workflows/$id',getParentRoute: () => userTTenantSlugRouteRoute
          })
const userTTenantSlugPromptsIdRoute = userTTenantSlugPromptsIdRouteImport.update({
            id: '/prompts/$id',path: '/prompts/$id',getParentRoute: () => userTTenantSlugRouteRoute
          })
const userTTenantSlugKnowledgeBasesIdRoute = userTTenantSlugKnowledgeBasesIdRouteImport.update({
            id: '/knowledge-bases/$id',path: '/knowledge-bases/$id',getParentRoute: () => userTTenantSlugRouteRoute
          })
const userTTenantSlugEvaluationsIdRoute = userTTenantSlugEvaluationsIdRouteImport.update({
            id: '/evaluations/$id',path: '/evaluations/$id',getParentRoute: () => userTTenantSlugRouteRoute
          })





const publicAuthRouteRouteChildren = {
  publicAuthLoginRoute: publicAuthLoginRoute,publicAuthIndexRoute: publicAuthIndexRoute,publicAuthResetPasswordTokenRoute: publicAuthResetPasswordTokenRoute,publicAuthVerifyApplyRoute: publicAuthVerifyApplyRoute,publicAuthVerifyRequestRoute: publicAuthVerifyRequestRoute,publicAuthResetPasswordIndexRoute: publicAuthResetPasswordIndexRoute
}

const publicAuthRouteRouteWithChildren = publicAuthRouteRoute._addFileChildren(publicAuthRouteRouteChildren)



const publicRouteRouteChildren = {
  publicAuthRouteRoute: publicAuthRouteRouteWithChildren,publicContactRoute: publicContactRoute,publicPricingRoute: publicPricingRoute,publicIndexRoute: publicIndexRoute,publicLegalSlugRoute: publicLegalSlugRoute,publicStoriesSlugRoute: publicStoriesSlugRoute,publicStoriesIndexRoute: publicStoriesIndexRoute
}

const publicRouteRouteWithChildren = publicRouteRoute._addFileChildren(publicRouteRouteChildren)




const usertenantBcRouteRouteChildren = {
  usertenantBcAccountRoute: usertenantBcAccountRoute,usertenantBcDashboardRoute: usertenantBcDashboardRoute,usertenantBcPurchaseRoute: usertenantBcPurchaseRoute,usertenantBcSettingsRoute: usertenantBcSettingsRoute,usertenantBcEvaluationsIdRoute: usertenantBcEvaluationsIdRoute,usertenantBcPromptsIdRoute: usertenantBcPromptsIdRoute,usertenantBcWorkflowsIdRoute: usertenantBcWorkflowsIdRoute,usertenantBcEvaluationsIndexRoute: usertenantBcEvaluationsIndexRoute,usertenantBcPromptsIndexRoute: usertenantBcPromptsIndexRoute,usertenantBcWorkflowsIndexRoute: usertenantBcWorkflowsIndexRoute
}

const usertenantBcRouteRouteWithChildren = usertenantBcRouteRoute._addFileChildren(usertenantBcRouteRouteChildren)




const userTTenantSlugRouteRouteChildren = {
  userTTenantSlugAccountRoute: userTTenantSlugAccountRoute,userTTenantSlugCheckoutRoute: userTTenantSlugCheckoutRoute,userTTenantSlugDashboardRoute: userTTenantSlugDashboardRoute,userTTenantSlugPurchaseRoute: userTTenantSlugPurchaseRoute,userTTenantSlugRunsRoute: userTTenantSlugRunsRoute,userTTenantSlugSettingsRoute: userTTenantSlugSettingsRoute,userTTenantSlugSubscriptionRoute: userTTenantSlugSubscriptionRoute,userTTenantSlugEvaluationsIdRoute: userTTenantSlugEvaluationsIdRoute,userTTenantSlugKnowledgeBasesIdRoute: userTTenantSlugKnowledgeBasesIdRoute,userTTenantSlugPromptsIdRoute: userTTenantSlugPromptsIdRoute,userTTenantSlugWorkflowsIdRoute: userTTenantSlugWorkflowsIdRoute
}

const userTTenantSlugRouteRouteWithChildren = userTTenantSlugRouteRoute._addFileChildren(userTTenantSlugRouteRouteChildren)



const userRouteRouteChildren = {
  usertenantBcRouteRoute: usertenantBcRouteRouteWithChildren,userOnboardingRoute: userOnboardingRoute,userTmpRoute: userTmpRoute,userTTenantSlugRouteRoute: userTTenantSlugRouteRouteWithChildren
}

const userRouteRouteWithChildren = userRouteRoute._addFileChildren(userRouteRouteChildren)

const rootRouteChildren = {
  publicRouteRoute: publicRouteRouteWithChildren,userRouteRoute: userRouteRouteWithChildren,AdminRoute: AdminRoute,OauthResultRoute: OauthResultRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)